import { parseViemError } from '../../../utils/error.utils'
import { ActionFlowError, BatchTxBundleError } from '../types.action-flow'

export function extractErrorMessage(error: unknown) {
  if (error instanceof ActionFlowError) {
    return error.message
  }
  if (error instanceof BatchTxBundleError) {
    return parseViemError(error.cause)
  }

  return parseViemError(error)
}
